<template>
<v-app>
<v-main>

<v-container
    v-if="url_params != null"
    style="max-width: 650px"
>

<div
    style="text-align:center; margin-top: 30px; margin-bottom:30px;"
>
    <img src="@/assets/redchirp-logo-transparent.png" width="250px" style="max-width: 90%"/>
</div>

<div
    v-if="!submitted"
>

    <h1>Next Step</h1>

    <div
        class="tell-us-more-title"
    >
        Tell us a bit more about your business so we can tailor your demo for you.
    </div>

    <v-select
        label="Choose your industry"
        :items="industry_choices"
        style="margin-top: 15px"
        v-model="industry"
        v-on:change="save"
    />


    <div
        v-if="industry == 'wine'"
    >
        <div class="cb-group-title">Which wine industry CRM(s) do you use?</div>
        <div
            v-for="(item, index) in wine_indstury_crm_choices"
            :key="'wine_crm_'+index"
            style="width: 50%; float: left"
        >
            <v-checkbox
                    :label="item.text"
                    class="my_cb"
                    v-model="crms"
                    :value="item.value"
                    v-on:change="save"
                />
        </div>
        <div style="clear: both;"></div>
    </div>

    <div
        v-if="industry == 'wine'"
        style="margin-top: 25px"
    >
        <div class="cb-group-title">What reservation platform(s) do you use?</div>
        <div
            v-for="(item, index) in wine_indstury_reservation_choices"
            :key="'wine_res_'+index"
            style="width: 50%; float: left"
        >
            <v-checkbox
                    :label="item.text"
                    class="my_cb"
                    v-model="reservation_systems"
                    :value="item.value"
                    v-on:change="save"
                />
        </div>
        <div style="clear: both;"></div>
    </div>

    <div
        v-if="industry == 'wine'"
        style="margin-top: 25px"
    >
        <div class="cb-group-title">Do you use any of these other programs? Check all that apply:</div>
        <div
            v-for="(item, index) in wine_industry_other_choices"
            :key="'wine_res_'+index"
            style="width: 50%; float: left"
        >
            <v-checkbox
                    :label="item.text"
                    class="my_cb"
                    v-model="other_systems"
                    :value="item.value"
                    v-on:change="save"
                />
        </div>
        <div style="clear: both;"></div>
    </div>

    <div
        style="text-align: right"
    >
        <v-btn
            color="primary"
            :disabled="!question_finished"
            v-on:click="submitted = true"
        >
            Submit
        </v-btn>
    </div>
</div>



<div
    v-if="submitted"
    style="margin-top: 25px"
>
    <div class="cb-group-title">Thanks!  We look forward to speaking with you!</div>

    <div
    style="text-align:center"
>
    <div class="confirmed">Confirmed</div>
    <div class="confirmed-with">You are scheduled with {{url_params.assigned_to}}</div>

</div>
    <div
        class="event-details-container"
    >
        <div
            class="event-title"
        >
            <v-icon>
                mdi-circle
            </v-icon>
            {{url_params.event_type_name}}
        </div>

        <div
            class="time"
        >
            <v-icon>
                mdi-calendar-account
            </v-icon>
            {{pretty_time}}    
        </div>

        <div
            class="time-zone"
        >
            <v-icon>
                mdi-earth
            </v-icon>
            {{pretty_timezone}}
        </div>

        <div
            class="zoom"
        >
            <v-icon>
                mdi-video
            </v-icon>
            Web conferencing details to follow.
        </div>

        <div
            class="email-to-follow"
        >
            A calendar invitiation has been sent to your email address.
        </div>

    </div>
</div>

</v-container>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>
const Time = require('@/js/time.js');
export default {

    data() {
        return {
            submitted: false,

            url_params: null,

            industry_choices: [
                {'text': 'Finance', 'value': 'uncategorized' },
                {'text': 'Health Care', 'value': 'health' },
                {'text': 'Wine', 'value': 'wine' },
                {'text': 'Other', 'value': 'uncategorized' },
            ],

            industry: null,

            wine_indstury_crm_choices: [
                {'text': 'None', 'value': 'none' },
                {'text': 'Commerce7', 'value': 'commerce7' },
                {'text': 'eCELLAR', 'value': 'ecellar' },
                {'text': 'OrderPort', 'value': 'order-port' },
                {'text': 'VinSuite', 'value': 'vinsuite' },
                {'text': 'WineDirect', 'value': 'winedirect' },
                {'text': 'Other', 'value': 'other' },
                {'text': 'It\'s Complicated', 'value': 'complicated' },
            ],

            wine_indstury_reservation_choices: [
                {'text': 'None', 'value': 'none' },
                {'text': 'Commerce7', 'value': 'commerce7' },
                {'text': 'eCELLAR', 'value': 'ecellar' },
                {'text': 'Fare Harbor', 'value': 'fare-harbor' },
                {'text': 'OrderPort', 'value': 'order-port' },
                {'text': 'Tock', 'value': 'tock' },
                {'text': 'Other', 'value': 'other' },
                {'text': 'It\'s Complicated', 'value': 'complicated' },
            ],

            wine_industry_other_choices: [
                {'text': 'Klaviyo', 'value': 'klaviyo' },
                {'text': 'Mailchimp', 'value': 'mailchimp' },
                {'text': 'Outshinery', 'value': 'outshinery' },
                {'text': 'WineShipping', 'value': 'wineshipping' },
                {'text': 'WineDirect Fulfillment', 'value': 'wine-direct-fulfillment' },
                {'text': 'WinePulse', 'value': 'winepulse' },
            ],

            crms: [],
            reservation_systems: [],
            other_systems: [],
        }
    },


    mounted () {
        let urlSearchParams = new URLSearchParams(window.location.search);
        this.url_params = Object.fromEntries(urlSearchParams.entries());
    },

    methods: {
        save()
        {
            let post_data = {
                ... this.url_params,
                'industry': this.industry,
                'crms': this.crms,
                'reservation_systems': this.reservation_systems,
                'other_systems': this.other_systems,
            };

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/sales/after-demo-booking-survey',
            
                'params' : post_data,
            
                'on_success': (data) => {
                    },
            
                'on_error': 'Unable to save your answers',
            });
        },
    },

    computed: {
        pretty_time() {
            let date = new Date(this.url_params.event_start_time);
            let end_date = new Date(this.url_params.event_end_time);

          
            let day_name = date.toLocaleDateString('en-US', { weekday: 'long' });
            let month_name = date.toLocaleDateString('en-US', { month: 'long' });

            let start_time = Time.getPeriodClockTimeFromDate(date);
            let end_time = Time.getPeriodClockTimeFromDate(end_date);
            
            return start_time+' - '+end_time+', '+day_name+' '+month_name+' '+date.getDate()+', '+date.getFullYear();
        },

        pretty_timezone() {
            let date = new Date(this.url_params.event_start_time);

            return date.toLocaleDateString('en-US', {day:'2-digit',timeZoneName: 'long' }).substring(4);
        },

        question_finished() {
            if ( this.industry == null ) return false;

            if ( this.industry == 'wine' )
            {
                return this.reservation_systems.length != 0;
            } 
            else
            {
                return true;
            }
        },
    },

}
</script>

<style lang="scss" scoped>
.confirmed
{
    font-weight: 700;
    color: rgba(0,0,0,0.7);
    font-size: 22px;
    margin-top: 15px;
    margin-bottom: 15px;
}

.confirmed-with
{
    padding-bottom: 35px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    margin-bottom: 15px;
}

.event-title
{
    font-weight: 700;
    color: rgba(0,0,0,0.7);
    font-size: 18px;
    margin-bottom: 15px;
}

.time,
.time-zone,
.zoom,
.email-to-follow,
{
     margin-bottom: 10px;
}

.email-to-follow,
.tell-us-more-title
{
    font-weight: 700;
    color: rgba(0,0,0,0.7);
}

h1
{
    color: rgba(0,0,0,0.7);
}


.event-details-container
{
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    margin-bottom: 15px;
}

.my_cb
{
    margin-bottom: -25px;
}

.cb-group-title
{
     font-weight: 700;
    color: rgba(0,0,0,0.7);
    text-align: center;
}

</style>

